import { render, staticRenderFns } from "./More.vue?vue&type=template&id=fc815ef0&scoped=true"
import script from "./More.vue?vue&type=script&lang=ts"
export * from "./More.vue?vue&type=script&lang=ts"
import style0 from "./More.vue?vue&type=style&index=0&id=fc815ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc815ef0",
  null
  
)

export default component.exports